import TagWriter from './TagWriter'

export default TagWriter